var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9133 25.4627C26.2054 24.2487 27.2346 22.7825 27.9375 21.1549C28.6404 19.5274 29.0021 17.7729 29 16C29 8.82 23.18 3 16 3C8.82001 3 3.00001 8.82 3.00001 16C2.99796 17.7729 3.35956 19.5274 4.06248 21.1549C4.76539 22.7825 5.79466 24.2487 7.08668 25.4627C9.49592 27.7385 12.6858 29.0045 16 29C19.3142 29.0045 22.5041 27.7385 24.9133 25.4627ZM8.19334 23.7493C9.12945 22.5782 10.3174 21.633 11.6689 20.9839C13.0204 20.3348 14.5007 19.9985 16 20C17.4993 19.9985 18.9797 20.3348 20.3312 20.9839C21.6827 21.633 22.8706 22.5782 23.8067 23.7493C22.7854 24.7809 21.5694 25.5995 20.2293 26.1575C18.8892 26.7155 17.4516 27.0019 16 27C14.5484 27.0019 13.1108 26.7155 11.7707 26.1575C10.4306 25.5995 9.21464 24.7809 8.19334 23.7493ZM21 12C21 13.3261 20.4732 14.5979 19.5355 15.5355C18.5979 16.4732 17.3261 17 16 17C14.6739 17 13.4022 16.4732 12.4645 15.5355C11.5268 14.5979 11 13.3261 11 12C11 10.6739 11.5268 9.40215 12.4645 8.46447C13.4022 7.52678 14.6739 7 16 7C17.3261 7 18.5979 7.52678 19.5355 8.46447C20.4732 9.40215 21 10.6739 21 12Z",
    fill: "#142038"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a69d15afae0dccdfc645ee7fe0f341f4.svg";
export { ForwardRef as ReactComponent };